// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"styles_buttonWrapper__rhs7K","deleteIcon":"styles_deleteIcon__j99uj"};